/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikProps } from 'formik';
import { MTag } from '@Components/Base';

import { filterLabels } from '../constants';

// import styles from './tags.module.css';

export const getArrKeyTags = (
  keys: string[],
  formik: FormikProps<any>,
  styles: {
    readonly [key: string]: string;
  }
): JSX.Element[] => {
  return keys
    .map((key) => {
      const arrValue = formik.values[key] as any[];

      return arrValue.map((arrValueItem) => (
        <MTag
          className={styles.tag}
          key={`${key} ${arrValueItem}`}
          closable
          onClose={() => {
            const newValue = arrValue.filter((item) => item !== arrValueItem);

            formik.setFieldValue(key, newValue).then(() => {
              formik.handleSubmit();
            });
          }}
        >
          <span className={styles.title}>{`${filterLabels[key]} - `}</span>
          <span className={styles.value}>{arrValueItem.toString()}</span>
        </MTag>
      ));
    })
    .flat() as unknown as JSX.Element[];
};
